const getPromosFromGroup = ({ Promocoes, Nome, Id }) =>
  Promocoes.map((promo) => ({
    ...promo,
    CodigoGrupo: Id, // adiciona o id do grupo como CodigoGrupo
    NomeGrupo: Nome, // adiciona o nome do grupo como NomeGrupo
  }));

/**
 * @param {array} response resposta da api do Lets
 * @param {object} param2 objeto com campo boolean returnGroups.
 *    returnGroups true: retorna array de grupos/pacotes
 *    returnGroups false: retorna array de promos
 */
const handlePromos = (response, { returnGroups = false } = {}) => {
  // Os dois endpoints de promos retornam um array de GRUPOS/PACOTES.
  // No caso do endpoint de hotel, os grupos são fake, tendo id 0
  const dynamicGroups = response.map((group) => {
    const Promocoes = getPromosFromGroup(group);

    if (!returnGroups) {
      return Promocoes;
    }

    // caso returnGroups=true retorna um objeto de grupo/pacote
    return {
      ...group,
      Codigo: group.Id, // adiciona o id do grupo como Codigo
      Imagem: { Url: group.Imagem }, // adiciona a imagem do grupo no mesmo
      // padrão das promoções com objeto { Url: Imagem }
      Promocoes,
    };
  });

  return returnGroups ? dynamicGroups : dynamicGroups.flat();
};

export default handlePromos;
